module.exports = __webpack_public_path__ + "static/img/1805_6.5c12f9a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/1805_6.jpg
// module id = QMhV
// module chunks = 1